export const CREATION_OF_THE_DAY_TEXT_1 = `Wow!! You've just made it to creation of the day! What an amazing achievement on your incredible creativity and effort!`;
export const CREATION_OF_THE_DAY_TEXT_2 =
  'That means your creation will be showcased at the very top of the Creative Gallery for everyone to see. How amazing!';
